import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { FadeContent } from "../Compartido/EfectesFonts";
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";

const ListaDestacados = ({ ruta, destacadas, config, lang }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    {/* ************* */ }

    return (
        <>
            {destacadas.map((propiedad, index) => {
                const href = "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica;
                return (
                    <div className="destacats-propietat bhh-property" key={index}>
                        <FadeContent blur={true} duration={200} easing="ease-out" initialOpacity={0} className="bhh-property__card">
                            <a href={href} className="bhh-property__media">
                                <span className="bhh-property__badge">{propiedad.ciudad}</span>
                                {
                                    propiedad.foto_principal.length != 0
                                        ? <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                        : <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src="/images/web/bedloop-nofoto.png" alt="" title="" />
                                }
                            </a>
                            <div className="bhh-property__body">
                                <span className="destacats-icones-propietat" style={{ color: "" + config.color_corporativo_web + "" }}>
                                    <i className="fa-solid fa-bed"></i> {propiedad['num_habitaciones']} | <i className="fa-solid fa-users"></i> {propiedad['capacidad_maxima']} | <i className="fa-solid fa-bath"></i> {propiedad['num_banyos']}
                                </span>
                                <h3 className="bhh-property__title"><a href={href}>{propiedad.nombre}</a></h3>
                                <a className="bhh-property__cta" href={href}>
                                    {
                                        propiedad.by_request == 1
                                            ? t("Petición")
                                            : t("Reservar")
                                    }
                                    <i className="fa-solid fa-plus"></i>
                                </a>
                            </div>
                        </FadeContent>
                    </div>
                );
            })}
        </>
    );
};

const Destacados = ({ destinos, ruta, destacadas, elementosweb, config, lang }) => {

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bhh-property', destacadas.length);

    return (

        <div className="pt-5 fons potblur bhh-destacados">
            <div className="bhh-section__head">
                <span className="bhh-eyebrow">{t("Nuestra selección")}</span>
                {elementosweb.subtitulo_propiedades && <h2 className="text-center">
                    {elementosweb.subtitulo_propiedades[lang]}
                </h2>}
            </div>

            <div className="bhh-destacados__carousel">
                <button
                    type="button"
                    disabled={navState.atStart}
                    onClick={() => scrollByCard(-1)}
                    className="bhh-destacados__prev"
                    aria-label={t("Anterior")}
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </button>
                <div className="bhh-destacados__track" ref={trackRef}>
                    <ListaDestacados
                        ruta={ruta}
                        destacadas={destacadas}
                        config={config}
                        lang={lang}
                    />
                </div>
                <button
                    type="button"
                    disabled={navState.atEnd}
                    onClick={() => scrollByCard(1)}
                    className="bhh-destacados__next"
                    aria-label={t("Siguiente")}
                >
                    <i className="fa-solid fa-arrow-right"></i>
                </button>
            </div>
        </div>
    );
};

export default Destacados;
